class customVariants extends HTMLElement {
    constructor() {
        super()
        this.sectionId = this.dataset.sectionId;
        this.options = document.querySelectorAll('[data-custom-option]');      
    }

    connectedCallback() {
        this.onVariantChanged();
    }

    onVariantChanged() {
        if (this.options.length > 0) {
            this.options.forEach((option)=> {
                option.addEventListener('click', ()=> {
                    const handle = option.dataset.handle;
                    this.changeVariant(handle);
                })
                option.addEventListener('keydown', ()=> {
                    const handle = option.dataset.handle;
                    this.changeVariant(handle);
                })
            })
        }
    }

    async changeVariant(handle) {
        const url = `${window.Shopify.routes.root}products/${handle}`;
        const response = await fetch(url);
        const result = await response.text();
        if (result) {
            const parser = new DOMParser().parseFromString(result, 'text/html');
            const productInfo = document.querySelector(`[data-section="${this.sectionId}"]`);
            const newProductInfo = parser.querySelector(`[data-section="${this.sectionId}"]`);
            if (productInfo && newProductInfo) {
                productInfo.innerHTML = newProductInfo.innerHTML;
                const newUrl = `${window.location.origin}${url}`;
                window.history.replaceState({}, '', newUrl)
            } else return    
        }
    }
}

customElements.define('product-custom-variants', customVariants)